import React from "react"
import PropTypes from "prop-types"
import TextField from "@material-ui/core/TextField"
import { fieldPropTypes } from "redux-form"

const FieldTextarea = ({
  type,
  label,
  placeholder,
  readonly,
  input,
  meta,
  ...custom
}) => {
  // code below enables to hide helperText at first render
  // it displays helper error only when
  //  - field has been visited, and field is invalid
  //  - form is submit (with or without visited field before) and field is invalid
  const { touched, error } = meta
  const { name, onBlur } = input

  let helperText
  if ((meta.visited || meta.submitFailed) && meta.invalid && !meta.active) {
    helperText = error
  }

  return (
    <TextField
      id={name}
      type={type}
      label={label}
      value={input.value}
      placeholder={placeholder}
      disabled={readonly}
      variant="outlined"
      size="small"
      error={touched && !!error}
      helperText={helperText}
      InputProps={{ onBlur }}
      {...input}
      {...custom}
    />
  )
}

FieldTextarea.propTypes = {
  ...fieldPropTypes,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool
}

FieldTextarea.defaultProps = {
  placeholder: "",
  readonly: false,
  onBlur: undefined
}

export default FieldTextarea
